import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import * as Sentry from "@sentry/react";
import { APP_CONFIG } from "./config/app-config.ts";

const environment = APP_CONFIG.getCurrentEnvironment();
const dsn = APP_CONFIG.getPublicRuntimeConfig().SENTRY_DSN;

if (
  environment === "production" ||
  environment === "development" ||
  environment === "staging"
) {
  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}
